import { Box, Typography } from "@mui/material";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import HighlightItem, { HighlightItemInfo } from "../components/HighlightItem";
import { Info } from "lucide-react";
import ClickableMinimizedTooltip from "../../tooltip/ClickableMinimizedTooltip";

const useStyles = makeStyles((theme) => ({
  card: {
    padding: 20,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 12,
  },
  title: {
    fontWeight: 600,
    fontSize: 14,
  },
  header: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: theme.spacing(2),

    [theme.breakpoints.down("sm")]: {
      gap: theme.spacing(2),
    },
  },
  icon: {
    color: theme.palette.grey[500],
    transition: theme.transitions.create(["color"]),
  },
}));

export interface ChartCardClasses {
  card?: string;
  title?: string;
}

interface ChartCardProps {
  title: string;
  children: React.ReactNode;
  classes?: Partial<ChartCardClasses>;
  highlight?: HighlightItemInfo;
  info?: string;
}

const ChartCard = (props: ChartCardProps) => {
  const { title, children, classes, highlight, info } = props;
  const s = useStyles();

  return (
    <Box className={clsx(s.card, classes?.card)}>
      <Box className={s.header}>
        <Box
          display={"flex"}
          flexDirection={"row"}
          alignItems={"center"}
          gap={1}
        >
          <Typography className={clsx(s.title, classes?.title)}>
            {title}
          </Typography>
          {info && (
            <ClickableMinimizedTooltip title={info} opacity={1}>
              <Info size={16} className={clsx(s.icon)} />
            </ClickableMinimizedTooltip>
          )}
        </Box>
        {!!highlight && <HighlightItem highlight={highlight} />}
      </Box>
      {children}
    </Box>
  );
};

export default ChartCard;
